export const bulkUnassignAccounts = async (
    API_URL: string,
    employerId: string,
    token: string,
    selectedEmployeeIds: string[],
    selectedPlanIds: string[]
) => {
    const response = await fetch(
        `${API_URL}/employers/${employerId}/employees/accounts`,
        {
            method: "DELETE",
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
            },
            body: JSON.stringify({
            employeeIds: selectedEmployeeIds,
            planIds: selectedPlanIds
            })
        }
    );

    if (!response.ok) {
        throw new Error("There was a problem un-assigning these accounts");
    }

    const responseBody = await response.json();

    return responseBody.jobId;
}